import { render } from "./MyCheck.vue?vue&type=template&id=64971c62&scoped=true"
import script from "./MyCheck.vue?vue&type=script&lang=js"
export * from "./MyCheck.vue?vue&type=script&lang=js"

import "./MyCheck.vue?vue&type=style&index=0&id=64971c62&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64971c62"]])

export default __exports__